module.exports = __webpack_public_path__ + "ic-punchcard.svg?b826bc18201db29ffa7b7030503d5911";